import { render } from "./ProjectDetails.vue?vue&type=template&id=034bf870&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"

import "./ProjectDetails.vue?vue&type=style&index=0&id=034bf870&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034bf870"]])

export default __exports__